module.exports = __webpack_public_path__ + "static/media/bannerP.4d1896e0.png";